// extracted by extract-css-chunks-webpack-plugin
module.exports = {"reviewShippingSection":"-DfRB","deliveryMsgTheme":"FURGb"};